import { Provider } from '@angular/core';

import { FactoryManageVacationsUseCasesImpl } from '@app/domain/use-cases/manage-vacations/factory/factory-manage-vacations.use-cases';
import { FACTORY_MANAGE_VACATIONS_USE_CASES } from '@app/domain/use-cases/manage-vacations/factory/factory-manage-vacations.use-cases.contract';

export const factoryManageVacationsUseCasesProvider: Provider = {
  provide: FACTORY_MANAGE_VACATIONS_USE_CASES,
  useClass: FactoryManageVacationsUseCasesImpl
};
